// src/services/orders.js
import axios from "axios";

// ✅ .env use karega
const API_BASE_URL = process.env.REACT_APP_API_URL;

export const fetchOrders = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}Order/ShowOrder?userId=${userId}&orderId=0`);
    return {
      ok: true,
      data: response.data?.data || [],
    };
  } catch (error) {
    return {
      ok: false,
      error: "Failed to fetch orders",
    };
  }
};